var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMentorBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#008FD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04505 12.64H10.5901V16.24C10.5901 17.08 11.0451 17.25 11.6001 16.62L15.3851 12.32C15.8501 11.795 15.6551 11.36 14.9501 11.36H13.4051V7.76001C13.4051 6.92001 12.9501 6.75001 12.3951 7.38001L8.61005 11.68C8.15005 12.21 8.34505 12.64 9.04505 12.64Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorBadge);
export default __webpack_public_path__ + "static/media/MentorBadge.531dbfaec09b152d005038c53bccf13c.svg";
export { ForwardRef as ReactComponent };